import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep5 } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull,
    MultipleGroupLastLarge
} from '../../containers/DefaultStyles/FormDetails';

class VoteRegistrationStep5Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: []
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
        this.showAllErrors = this.showAllErrors.bind(this);
        this.checkForBlurError = this.checkForBlurError.bind(this);
    }

    checkForBlurError(name) {
        if (this.props.validationErrors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    showAllErrors(){
        this.setState({ errors: this.props.validationErrors });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupLastLarge>
                    <Field
                        name="mailingAddress"
                        onBlur={() => this.checkForBlurError('mailingAddress')}
                        submissionError={this.state.errors.includes('mailingAddress')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Mailing Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                    <Field
                        name="mailingUnit"
                        onBlur={() => this.checkForBlurError('mailingUnit')}
                        submissionError={this.state.errors.includes('mailingUnit')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Mailing Unit"
                        placeholder="Unit"
                        autocomplete="off"
                    />
                </MultipleGroupLastLarge>
                <MultipleGroupFull>
                    <Field
                        name="mailingCity"
                        onBlur={() => this.checkForBlurError('mailingCity')}
                        submissionError={this.state.errors.includes('mailingCity')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Mailing city"
                        placeholder="City"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="mailingStateId"
                        onBlur={() => this.checkForBlurError('mailingStateId')}
                        submissionError={this.state.errors.includes('mailingStateId')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.states}
                        defaultOption={'Choose'}
                        label="Mailing State"
                        type="text"
                    />
                    <Field
                        name="mailingPostalCode"
                        onBlur={() => this.checkForBlurError('mailingPostalCode')}
                        submissionError={this.state.errors.includes('mailingPostalCode')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Mailing Postal code"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                            onClick={this.showAllErrors}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep5Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    states: PropTypes.array,
    validationErrors: PropTypes.object
};

export default compose(
    connect((state,props) => ({
        initialValues: {
            mailingAddress: state.cachedFormData.address || '',
            mailingUnit: state.cachedFormData.unit || '',
            mailingCity: state.cachedFormData.city || '',
            mailingStateId: state.cachedFormData.stateId || '',
            mailingPostalCode: state.cachedFormData.postalCode || ''
        },
        validationErrors: Object.keys(props.validationErrors || {})
    })),
    reduxForm({
        form: 'voteRegistrationStep5Form',
        validate: validateStep5,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep5Form);
